// Base.api: axios wrappers and shared error handling for www API calls.
// Mistake: /log/www CORS/network errors redirected to /error/500; ignore logging failures.
import axios from "axios";
import { getQueryStringFromObject } from "helpers/Api.helper";

export const get = async (url: string, queryString = {}) => {
    console.log("Api.service:get");
    const params = getQueryStringFromObject(queryString);
    return axios
        .get(`${url}${params}`)
        .then(({ status, data }) => {
            if (status === 200) {
                return data.data;
            }
        })
        .catch(errorHandler);
};

export const post2 = async (url: string, params: any = {}) => {
    console.log("Api.service:post2");
    return axios.post(url, params)
        .then(({ status, data }) => {
            if (status === 200) {
                return data.data;
            }
        }).catch(errorHandler);
};

export const post = async (url: string, params: any = {}) => {
    console.log("Api.service:post");

    return axios
        .post(url, params)
        .then(({ status, data }) => {
            return { status, data };
        })
        .catch(errorHandler);
};

export const put = async (url: string, params: any): Promise<any> => {
    console.log("Api.service:put");

    return axios
        .put(url, params)
        .then(({ status, data }) => {
            return { status, data };
        })
        .catch(errorHandler);
};

export const patch = async (url: string, params: any = null): Promise<any> => {
    console.log("Api.service:put");

    return axios
        .patch(url, params)
        .then(({ status, data }) => {
            return { status, data };
        })
        .catch(errorHandler);
};

export const remove = async (url: string, queryString = {}) => {
    console.log("Api.service:remove");
    const params = getQueryStringFromObject(queryString);

    return axios
        .delete(`${url}${params}`)
        .then(({ status, data }) => {
            return { status, data };
        })
        .catch(errorHandler);
};

export const remove2 = async (url: string, queryString = {}) => {
    console.log("Api.service:delete2");
    const params = getQueryStringFromObject(queryString);
    return axios.delete(`${url}${params}`)
        .then(({ status, data }) => {
            if (status === 200) {
                return data.data;
            }
            return { status, data };
        })
        .catch(errorHandler);
};

const errorHandler = (error: any): never | null => {
    const { response } = error;
    const url = String(error?.config?.url || "");
    console.log("API Error:", error);
    if (error.stack) {
        console.error("Error stack:", error.stack);
    }
    if (!response) {
        // If logging fails due to CORS/network, do not break the user flow.
        if (url.includes("/log/www")) {
            console.warn("API Error (ignored): /log/www network/CORS failure", { url });
            return null;
        }
        window.location.href = "/error/500";
    } else if (response.status === 403) {
        console.log(response.data.errorCode);
        if (response.data.errorCode !== 'BLOCKED_ACCOUNT') {
            alert(response.data.message);
            window.location.href = "/login";
        }
        throw response.data;
    } else {
        if (response.data) {
            if (!response.data.message) {
                response.data.message = "Unknown Error Occurred";
            }
        }
        throw response.data;
    }
};
